import React, { Component,Fragment } from 'react';
import "../animate/animate.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import './first.css';

class first extends Component {
  constructor(props){
    super(props)
      this.state={
        isMobile:false,
        showLine:false,
        navigator:[
          {
            title:'首页',
            pagePath:'/'
          },
          {
            title:'解决方案',
            pagePath:'/solution'
          },
          {
            title:'产品中心',
            pagePath:'/product'
          },
          {
            title:'关于我们',
            pagePath:'/about'
          }

        ]
      }
  }
   componentDidMount(){
     console.log(window.innerWidth);
     
   
  }

  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    const sliderArr =  global.constants.channel==="mengduo" ? [
      { title: 'AiMEASURE', smallTitle: '[智量]Ai智能拍照量体服务', img: require('../image/mengduo/3423.png'), content: '融合机器视觉与人体尺寸大数据,用户只需用手机拍摄正面、侧面两张照片,经过训练的神经网络会自动识别人体上的关键点,并胸围、肩宽、腰围等30余项身体数据.整套系统经数万级图像训练的深度学习算法模型,具有完善的神经网络及深度学习能力.' },
    ] :
    [
      { title: 'AiMEASURE', smallTitle: '[智量]Ai智能拍照量体服务', img: require('../image/body.png'), content: '融合机器视觉与人体尺寸大数据,用户只需用手机拍摄正面、侧面两张照片,经过训练的神经网络会自动识别人体上的关键点,并胸围、肩宽、腰围等30余项身体数据.整套系统经数万级图像训练的深度学习算法模型,具有完善的神经网络及深度学习能力.' },
      { title: 'OMS订单管理系统', smallTitle: '高保真3D模型让服装定制可视化', img: require('../image/haisibao.png'), content: '自主研发的3D引擎技术，将传统的工艺代码下单用3D模型实时渲染呈现，可以将定制效果更直观的展现给客户，降低沟通成本的同时，大大降低了代码下单的出错率。系统内部集成了客户管理、订单管理、储值卡管理等门店系统的必备功能，足以满足门店的运营管理需要.' },
    ];
    return (
      <Fragment>
        {!global.constants.isMobile && 
          <Slider {...settings} className="row-section-contain">
            {sliderArr.map(({ title, smallTitle, img, content }) => (
              <Fragment>
                <div key={title} className="row-section-contain-content" >
                  <div className="left-container">
                    <div className="row-section-contain-t">{title}</div>
                    <div className="App-intro-2">{smallTitle}</div>
                    <div className="App-intro-3">{content}</div>
                  </div>
                  <div className="right-container">
                    <img src={img} className="man"/>
                  </div>
                </div>
              </Fragment>
            ))}
          </Slider>
        }
      </Fragment>
    );
  }
}

export default first;



// WEBPACK FOOTER //
// ./src/components/first.js